import {
  Outlet,
  Link,
  createRootRouteWithContext,
  useRouter,
} from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

function NotFoundComponent() {
  return (
    <div className="flex min-h-dvh items-center justify-center px-4" style={{ background: "#EFE7DB" }}>
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-extrabold text-[#2E2438]">404</h1>
        <p className="mt-2 text-sm text-[#5A4F63]">That page doesn't exist.</p>
        <div className="mt-6">
          <Link to="/" className="inline-flex items-center justify-center rounded-full bg-[#7A4FE0] px-5 py-2.5 text-sm font-semibold text-white">
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}

function ErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  console.error(error);
  const router = useRouter();
  return (
    <div className="flex min-h-dvh items-center justify-center px-4" style={{ background: "#EFE7DB" }}>
      <div className="max-w-md text-center">
        <h1 className="text-xl font-bold text-[#2E2438]">Something broke</h1>
        <p className="mt-2 text-sm text-[#5A4F63]">{error.message}</p>
        <button
          onClick={() => { router.invalidate(); reset(); }}
          className="mt-6 inline-flex items-center justify-center rounded-full bg-[#7A4FE0] px-5 py-2.5 text-sm font-semibold text-white"
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  errorComponent: ErrorComponent,
});

function RootComponent() {
  return <Outlet />;
}
